import type { FaireProductEntity } from "../../entity_types/product";

export const p_zymfb4tuq5: FaireProductEntity = {
  token: "p_zymfb4tuq5",
  type: "product",
  name: "The Wool Stripe Throw - Burnt Umber Stripe - FW26",
  brandToken: "b_3mgp73jmn6",
  brandName: "Arctic Fox & Co. - North America",
  imageUrl:
    "https://cdn.faire.com/fastly/e6c31222927c37bea98aee4af982b161dd1c2cf9df62fc67d39ebeb839415ffe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/954d0a09bb3d715b23f1b20588c64c4bfa7c652c34209356b496d1230474472e.jpeg",
    "https://cdn.faire.com/fastly/04d49ef8697e5eb4530c60060cb6029e5b3656c68ac676e6cc4983f7fb582eba.jpeg",
    "https://cdn.faire.com/fastly/387ff330f1be33932d2734442916e185e48d1772d2dc2e406b64d4137c063476.jpeg",
    "https://cdn.faire.com/fastly/f25aa4cb3e84f9fdbd25a14994a3bcc3f83a313e818520be839d3e11fe07d9e6.jpeg",
    "https://cdn.faire.com/fastly/52f27b339e269c50cface2e8e853f2c68db42ff3ac22f4404b7cba9f6cc9318a.jpeg",
    "https://cdn.faire.com/fastly/16690ed55a9fba2b3e1cb0ffeed752da9f4d51ac0a3a8d4f5610649c09290451.jpeg",
    "https://cdn.faire.com/fastly/3b93c51bd5ddb5783867498038b8558e9c558f14338af35488fc1e2f8cdb2db3.jpeg",
    "https://cdn.faire.com/fastly/9ec45c79f21822097da299ba349f7a7b1988b168f1fbf19126e1f265850d2b44.jpeg",
  ],
  priceDollars: 43.28,
  description:
    'The Wool Stripe Throw is a proven customer favourite that elevates our bestselling throw collection with the premium warmth and softness of merino wool.\n\nCrafted from a considered blend of merino wool and recycled polyester, it showcases the irresistibly soft, brushed texture for which Arctic Fox is known. The addition of wool provides enhanced warmth and a beautifully premium handle, while the recycled fibres create a comfortable and practical design for everyday living.\n\nFeaturing a timeless striped design in versatile, interior-friendly colourways, it brings warmth, texture and understated colour to sofas, beds and cosy corners. Its proven sales history and premium feel offer retailers strong homeware and gifting appeal.\n\nKey features:\n\n•\tProven customer favourite with two previous sell-out runs\n•\tCrafted with premium RWS-certified merino wool\n•\tContains 90% recycled polyester\n•\tExceptionally soft, warm and beautifully brushed\n•\tTimeless striped design\n•\tVersatile colourways designed to complement modern interiors\n•\tStrong seasonal gifting and homeware appeal\n\nMaterials: 10% RWS-certified merino wool, 90% recycled polyester\nPlastic free packaging: arrives in our 100% paper protective bags.\nSize: 200 cm x 135 cm (78" x 53")',
  tags: [],
  msrpDollars: 100,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:40.675Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
